import React from 'react'
import IncomeAttributeTableFragmentGenerator from '../../../utils/TableGenerator/IncomeAttributeTableFragmentGenerator'
import IncomeAttributeLookupObject from '../../../types/lookups/IncomeAttributeLookupObject'


interface MotelRevenueTabProps {
    lookups: IncomeAttributeLookupObject[],
    incomeAttributes?: Record<string, unknown>[],
    valueChangeHandler: (newAmt: number | undefined | null, name: string, oldAmt: number | undefined | null) => void,
    handleCommentChange: (value: string, name: string) => void,


}


function MotelRevenueTab(props: MotelRevenueTabProps) {
    const { lookups, incomeAttributes, valueChangeHandler, handleCommentChange } = props

    return (
        <>
            {lookups &&
                <table className="table-with-border pie-table accordion-content">
                    <thead>
                        <tr>
                            <th id="attribute-label" scope="col"></th>
                            <th id="attribute-value" scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            lookups.map((lookup, key) => {
                                const incomeAttributesData = incomeAttributes && (incomeAttributes as Record<string, unknown>[]).find(({ code }) => code === lookup.incomeAttributeCode)
                                if (["7", "8"].includes(lookup.incomeAttributeCode)) {
                                    return <IncomeAttributeTableFragmentGenerator key={key} attribute={lookup}
                                        data={incomeAttributesData}
                                        valueChangeHandler={valueChangeHandler}
                                        handleCommentChange={handleCommentChange}
                                        showSubheading={false}
                                        hasInputLabel={true}
                                        isPlaceHolderWithAttrDesc={true}
                                        isOtherLabel={false}
                                        isRequiredField={false}
                                        isReplacementReserve={false}
                                    />
                                } else if (lookup.incomeAttributeCode === '12') {
                                    return <IncomeAttributeTableFragmentGenerator key={key} attribute={lookup}
                                        data={incomeAttributesData}
                                        valueChangeHandler={valueChangeHandler}
                                        handleCommentChange={() => null}
                                        showSubheading={false}
                                        hasInputLabel={false}
                                        isOtherLabel={false}
                                        isRequiredField={true}
                                        isReplacementReserve={false}
                                    />
                                } else {
                                    return <IncomeAttributeTableFragmentGenerator key={key} attribute={lookup}
                                        data={incomeAttributesData}
                                        valueChangeHandler={valueChangeHandler}
                                        handleCommentChange={() => null}
                                        showSubheading={false}
                                        hasInputLabel={false}
                                        isOtherLabel={false}
                                        isRequiredField={false}
                                        isReplacementReserve={false}
                                    />
                                }
                            })
                        }
                    </tbody>
                </table>
            }
        </>
    )
}

export default MotelRevenueTab